import React from "react";
import { Zap } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { id: "services", label: "Services", testid: NAV.linkServices },
  { id: "about", label: "About", testid: NAV.linkAbout },
  { id: "contact", label: "Contact", testid: NAV.linkContact },
];

const handleScroll = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  return (
    <header className="pe-nav" data-testid={NAV.root}>
      <div className="container-pe flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          onClick={handleScroll("top")}
          className="flex items-center gap-3"
          data-testid={NAV.logo}
        >
          <div className="leading-tight">
            <div className="font-display text-base md:text-lg tracking-[0.18em] text-white">
              PEREZ ELECTRIC
            </div>
            <div className="font-mono text-[10px] tracking-[0.28em] text-[var(--pe-gold)] uppercase">
              Licensed · Insured
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={handleScroll(l.id)}
              data-testid={l.testid}
              className="font-mono text-xs tracking-[0.24em] uppercase text-[var(--pe-muted)] hover:text-[var(--pe-gold)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#quote"
            onClick={handleScroll("quote")}
            data-testid={NAV.ctaQuote}
            className="pe-btn pe-btn-primary"
          >
            <Zap className="h-4 w-4" />
            Get Quote
          </a>
        </div>
      </div>
    </header>
  );
}
